import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor() {
  }

  onError(payload: { error: any, message?: string, data?: any }) {
    console.error(payload.error, '\n', payload?.message, payload?.data);
  }
}
